export default {
  isLoading: state => state.common.isLoading
}
